import React from 'react';

interface ProductSlotProps {
  translation: string;
}

const ProductSlot = ({ translation }: ProductSlotProps) => {
  return <div className="product-slot">{translation}</div>;
};

export default ProductSlot;
